export default "__VITE_ASSET__77174f52__"